export const IGetPushNotificationUseCaseType = Symbol('IGetPushNotificationUseCase');
